import { JobLocation } from './job-location';

export class Job {
  id: number;
  jobLocationId: number;
  title: string;
  htmlContent: string;
  jobLocation: JobLocation;
}
